import axios from 'axios'

const _getFormData = (item) => {
  const formData = new FormData()
  if (item.title) formData.append('title', item.title)
  if (item.description) formData.append('description', item.description)
  if (item.date) formData.append('date', item.date)
  if (item.type) formData.append('type', item.type)
  if (item.done) formData.append('done', item.done)
  if (item.duration) formData.append('duration', item.duration)
  if (item.link) formData.append('link', item.link)
  if (item.classroom_id) formData.append('classroom_id', item.classroom_id)
  if (item.teacher_id) formData.append('teacher_id', item.teacher_id)
  if (item.student_id) formData.append('student_id', item.student_id)
  return formData
}

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    conferences: [],
    next_conferences: [],
    next_loading: false,
  },
  mutations: {
    SET(state, data) {
      state.conferences = data;
    },
    ADD(state, item) {
      // On ne connait pas l'ordre de la date de l'evenement qui vient d'etre ajoute
      // state.next_dates.unshift(item)
    },
    UPDATE(state, next_dates) {
      // On ne connait pas l'ordre de la date de l'evenement qui vient d'etre ajoute
      // const index = state.next_dates.findIndex((p) => p.id === next_dates.id)
      // if (index >= 0) Object.assign(state.next_dates[index], next_dates)
    },
    REMOVE(state, itemId) {
      const ItemIndex = state.conferences.findIndex((p) => p.id === itemId)
      state.conferences.splice(ItemIndex, 1)
    },
    SET_LOADING(state, value) {
      state.next_loading = value;
    },
    SET_NEXT_CONFERENCES(state, value) {
      state.next_conferences = value;
    }
  },
  actions: {
    fetchDataListItems({commit, state}, params) {
      return new Promise((resolve, reject) => {
        axios.get('/conference', {params: params})
          .then((response) => {
            commit('SET', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    fetchNextConferences({commit, state}) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        axios.get('/next_conferences')
          .then((response) => {
            commit('SET_NEXT_CONFERENCES', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('SET_LOADING', false)
          })
      })
    },
    getItem({commit}, itemId) {
      return axios.get('/conference/' + itemId)
    },
    updateItem({commit}, item) {
      return new Promise((resolve, reject) => {
        axios.post(`/conference/${item.id}`, {
          title: item.title,
          description: item.description,
          date: item.date,
          type: item.type,
          done: item.done,
          duration: item.duration,
          link: item.link,
          classroom_id: item.classroom_id,
          teacher_id: item.teacher_id,
          student_id: item.student_id,
          _method: 'PATCH'
        })
          .then((response) => {
            commit('UPDATE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            x
            reject(error)
          })
      })
    },
    addItem({commit}, item) {
      return new Promise((resolve, reject) => {
        axios.post('/conference', item)
          .then((response) => {
            commit('ADD', response.data)
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    removeItem({commit}, itemId) {
      return axios.delete(`/conference/${itemId}`)
        .then((response) => {
          commit('REMOVE', itemId)
          return Promise.resolve()
        })
    },
  },
  getters: {
    conferences: state => state.conferences,
    next_conferences: state => state.next_conferences,
    next_loading: state => state.next_loading
  }
}
